<template>
  <div>
    <NavBar />
    <NewSecurityQuestion @created="getSecurityQuestions" />
    <ViewSecurityQuestion
      :question="question"
      @updated="getSecurityQuestions"
    />
    <b-overlay :show="loading" opacity="0.99">
      <b-container>
        <b-row>
          <b-col>
            <v-card>
              <v-card-title>
                <b-row align-v="center">
                  <b-col cols="auto">
                    <v-btn
                      class="v-primary"
                      @click="$bvModal.show('new_security_question')"
                    >
                      <i class="fa fa-plus mr-1" /> Nova
                    </v-btn>
                  </b-col>
                  <b-col cols="auto"> Perguntas de segurança </b-col>
                  <b-col>
                    <v-text-field
                      class="m-0 p-0"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Pesquisar"
                      single-line
                      hide-details
                    />
                  </b-col>
                </b-row>
              </v-card-title>
              <v-card-text>
                <ErrorsMessages :errors="errors" />
                <b-row>
                  <b-col> </b-col>
                </b-row>
                <div class="col">
                  <v-data-table
                    dense
                    :headers="headers"
                    :items="security_questions"
                    :search="search"
                    :footer-props="{
                      'items-per-page-options': [25, 75, 100],
                      'items-per-page-text': 'Mostrar',
                    }"
                    @click:row="openViewModal"
                  >
                  </v-data-table>
                </div>
              </v-card-text>
            </v-card>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import NewSecurityQuestion from "../templates/Default/SecurityQuestion/NewSecurityQuestion";
import ViewSecurityQuestion from "../templates/Default/SecurityQuestion/ViewSecurityQuestion";
import NavBar from "../templates/NavBar";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import api from "../services/api";

export default {
  name: "SecurityQuestions",
  components: {
    NavBar,
    ErrorsMessages,
    NewSecurityQuestion,
    ViewSecurityQuestion,
  },
  data() {
    return {
      errors: [],

      loading: false,

      search: "",
      headers: [
        { text: "Código", sortable: false, value: "id" },
        { text: "Enunciado", value: "statement" },
      ],
      security_questions: [],
      question: null,
    };
  },
  created() {
    this.getSecurityQuestions();
  },
  methods: {
    async getSecurityQuestions() {
      this.loading = true;

      try {
        const response = await api.get("/default/security-questions");
        const { error, errors, security_questions } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.security_questions = security_questions;
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },

    openViewModal(item) {
      this.question = item;
    },
  },
};
</script>